import "./LoadingNotice.scss";

export const LoadingNotice = (): JSX.Element => {
  return (
    <p className="loadingNotice">Loading...</p>
  );
};
